import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AuthPage = lazy(() => import('../pages/auth/page'));
const ChatPage = lazy(() => import('../pages/chat/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <AuthPage />,
  },
  {
    path: '/chat',
    element: <ChatPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
